import styles from 'styles/modules/FilePreview.module.scss';
import Download from 'components/Svg/Download';
import {
    getFileExtension,
    getFileExtPreview,
    getShortFileName,
} from 'helpers/file';
import Remove from 'components/Svg/Remove';
import PopupConfirm from 'components/popUps/PopupConfirm';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from 'store/auth';
import { removeFile } from 'store/company';

const FilePreview = ({ id, title, name, url }) => {
    const dispatch = useDispatch();
    const { isAuthorized } = useSelector(authSelector);
    const shortName = getShortFileName(name);
    const [confirming, setConfirming] = useState(false);
    const [removing, setRemoving] = useState(false);
    let preview;

    const handleRemove = async () => {
        setRemoving(true);
        await dispatch(removeFile(id));
        setRemoving(false);
        setConfirming(false);
    };

    if (
        name.includes('jpg') ||
        name.includes('jpeg') ||
        name.includes('png') ||
        name.includes('webp')
    ) {
        preview = (
            <a
                href={url}
                download={name}
                target="_blank"
                className={['border-gray', styles.thumbnail].join(' ')}
                style={{
                    backgroundImage: `url(${url})`,
                }}
                rel="noreferrer"
            />
        );
    } else {
        preview = (
            <a
                href={url}
                download={name}
                target="_blank"
                className={['border-gray', styles.thumbnail].join(' ')}
                rel="noreferrer"
            >
                {getFileExtPreview(getFileExtension(name))}
            </a>
        );
    }

    return (
        <div className={styles.wrapper}>
            {preview}
            <div className={styles.information}>
                <a
                    href={url}
                    download={name}
                    target="_blank"
                    className={styles.title}
                    rel="noreferrer"
                >
                    {title || `File ${id}`}
                </a>
                <span className={styles.name}>{shortName}</span>
            </div>
            <div className={styles.icons}>
                <a href={url} download={name} target="_blank" rel="noreferrer">
                    <Download />
                    Download
                </a>
                {isAuthorized && (
                    <button type="button" onClick={() => setConfirming(true)}>
                        <Remove />
                        Remove
                    </button>
                )}
            </div>
            <PopupConfirm
                active={confirming}
                title={`Remove ${title || name}?`}
                body="It disappears from your Media Pack straight away."
                confirmTitle="Remove"
                loading={removing}
                onConfirm={handleRemove}
                onCancel={() => setConfirming(false)}
            />
        </div>
    );
};

export default FilePreview;
